var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgPlayerB7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 145,
    viewBox: "0 0 100 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 29.5L6.5 34.5L9 37L14.5 39L13.5 36.5L13 32L14 28L16 24.5L20 22L24.5 20.5L30 20L34.5 20.5L37 22L39.5 25L41 27.5L41.5 28.5L49.5 29V29.5L48.5 30L46 31L43.5 32L46 34L47 36L51 41L51.5 42.5V44.5L51 47L50 48.5L48.5 49H45.5V50.5V51.5L44.5 52.5L43.5 53L41 54V55L48 58L51.5 60.5L56.5 61.5L60 64L69 64.5L74 57L78 50.5V48.5L77 47L76 46.5L75.5 45.5L72.5 38.5V37L74 36.5L75.5 37.5L77.5 39.5L83.5 30L84.5 29.5L86 30L86.5 30.5L87.5 30H89L90 30.5L90.5 31.5L92 32L92.5 32.5V34L93 35H94L95 35.5L95.5 36.5L93 40L92 43L90 47.5L87.5 51L87 61.5L86 64L79 78L68 82L72.5 90L75.5 98.5L77.5 108.5V119.5L78 122L79 126.5L84.5 135L87.5 144.5H28L26 136.5L27.5 130L30.5 124.5L33.5 122.5L32 120V116L31 108.5L30 106L28.5 104L17.5 73.5L13 58.5L0 43.5V29.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPlayerB7);
export default __webpack_public_path__ + "static/media/bg_player_b7.2eef88bed592a5c731ae08b88934fd58.svg";
export { ForwardRef as ReactComponent };